import React, { useMemo } from 'react';
import SearchBarTypeahead, {
    ISearchBarTypeaheadOption,
} from '../../../../components/SearchBarTypeahead';
import useTranslate from '../../../../../customHooks/useTranslate';
import { useZitoneoServices } from '../../../contexts/ZitoneoContentContext';
import { ComplementaryServiceTypeState } from '../../../types/zitoneoServicesTypes';
import { createNewHotelService } from '../../../utils/zitoneoServicesUtils';

const SearchServices = () => {
    const translate = useTranslate();
    const {
        ComplementaryServiceTypes,
        ComplementaryServiceCategories,
        handleAddService,
        handleFocusHotelService,
        handleSelectCategory,
    } = useZitoneoServices();

    const categoryNameById = useMemo(
        () =>
            ComplementaryServiceCategories.reduce<Record<number, string>>(
                (accumulator, category) => {
                    accumulator[parseInt(category.Id)] = category.Name;
                    return accumulator;
                },
                {}
            ),
        [ComplementaryServiceCategories]
    );

    const searchOptions = useMemo<
        ISearchBarTypeaheadOption<ComplementaryServiceTypeState>[]
    >(
        () =>
            ComplementaryServiceTypes.map(service => ({
                id: service.Id,
                label: service.Name,
                value: service.Id,
                group: categoryNameById[service.IdServiceCategory] || undefined,
                data: service,
            })),
        [ComplementaryServiceTypes, categoryNameById]
    );

    return (
        <div className='zitoneo-header__search-services__container'>
            <SearchBarTypeahead
                options={searchOptions}
                value={null}
                placeholder={translate('search_service')}
                resetInputValueOnSelect={true}
                onSelect={option => {
                    if (!option) return;
                    const selectedService = ComplementaryServiceTypes.find(
                        service => service.Id === option.id.toString()
                    );
                    if (!selectedService) return;
                    const selectedCategory =
                        ComplementaryServiceCategories.find(
                            category =>
                                parseInt(category.Id) ===
                                selectedService.IdServiceCategory
                        );
                    if (!selectedCategory) return;

                    handleSelectCategory(selectedCategory);

                    const newService = createNewHotelService(
                        selectedService,
                        selectedCategory
                    );

                    handleFocusHotelService(newService.Id);
                    handleAddService(newService);
                }}
            />
        </div>
    );
};

export default SearchServices;
